import { lazy } from "react";
import { OrderDetails } from "./View/OrderDetails/index";
import { CheckoutMain } from "./View/CheckOutNew/CheckOutMain.jsx";
import { BillInfoMain } from "./View/BillInfo/BillinfoMain";
import { OrderStatusMain } from "./View/OrderStatus/orderStatusMain";
import { ProductHybridMain } from "./View/ProductHybrid/hybridPage";
import { ForgotPasswordMain } from "./View/ForgotPassword/ForgotPasswordMain";
import { ForgotUsernameMain } from "./View/ForgotUsername/ForgotUsernameMain";
import { MyAccount } from "./View/MyAccount";
import { LoginFormContainer } from "./View/Login/loginFormContainer";
import { MyWalletMain } from "./View/MyAccount/myWallet/myWalletMain";
import { MyWalletNewCard } from "./View/MyAccount/myWallet/myWalletNewCard";
import { ChangePassword } from "./View/MyAccount/ChangePassword/changePassword";
import { ChangeUsername } from "./View/MyAccount/ChangeUsername/changeUsername";
import { AddNewAddress } from "./View/MyAccount/addressBook/AddNewAddress";
import { MyAccountProfile } from "./View/MyAccount/MyAccountDetails/myAccountProfile";
import { WebsiteSettings } from "./View/MyAccount/WebsiteSettings/websiteSettings";
import { AiAccessTokens } from "./View/MyAccount/AiAccess/aiAccessTokens";
import { OAuthConsent } from "./View/MyAccount/AiAccess/oauthConsent";
import { SignupMain } from "./View/Registration/SignupMain";
import { ResetPasswordComp } from "./View/ResetPassword/ResetPassword";
import { PowerSearchMainLite } from "./View/PowerSearchLite/powerSearchLite";
import { CompanyUsers } from "./View/MyAccount/CompanyUsers/companyUsers";
import { CompanyUsersEditusers } from "./View/MyAccount/CompanyUsers/CompanyUsersEditusers";
import { AlgoliaCategoryMain } from "./View/CategoryAlgolia/algoliaCategoryMain";
import { Online_catalogue_Main } from "./View/Online_catelogue/Online_catalogue_Main";
import { EbookMain } from "./View/Ebook/EbookMain";
import { HomePageMainContainer } from "./View/HomeNew/homePageMainContainer";
import { ProductPageAlgolia } from "./View/HomeNew/productPageAlgolia";
import { MyFavouriteProductMain } from "./View/MyAccount/favouriteProducts/myFavouriteProductMain";
import { MyPendingOrderMain } from "./View/MyAccount/PendingOrderList/pendingOrdersMain";
import { MyAddressBookMain } from "./View/MyAccount/addressBook/addressBookMain";
import { ManufacturerPage } from "./View/BrandAlgolia/manfacturerPage";
import { BrandPageMain } from "./View/BrandAlgolia/brandPageMain";
import { CompatibleBrandMain } from "./View/CompactableBrandAlgolia/compatibleBrandMain";
import { AboutUs } from "./View/StaticPage/AboutUs";
import { ContactUs } from "./View/StaticPage/ContactUs";
import { Termsandconditions } from "./View/StaticPage/Termsandconditions";
import { PrivacyPolicy } from "./View/StaticPage/Privacepolicy";
import { JobEnquiries } from "./View/StaticPage/JobEnquiries";
import { PaymentPolicy } from "./View/StaticPage/PaymentPolicy";
import { UserGuide } from "./View/StaticPage/UserGuide";
import { FAQ } from "./View/StaticPage/FAQ";
import { MyOrderHistoryMain } from "./View/MyAccount/MyOrderList/myOrderHistoryMain";
import { PayOnlineMain } from "./View/PayOnline/PayOnlineMain";
import { MakePaymentMail } from "./View/MakePaymentMail/MakePaymentMail";
import { PayAccountMain, PayAccountLegacyRedirect } from "./View/MyAccount/Payaccount/PayAccountMain";
import { PaymentSuccess } from "./View/MyAccount/Payaccount/PaymentSuccess";
import { PayInvoiceMain } from "./View/PayInvoice/PayInvoiceMain";
import { TrackOrderMain } from "./View/trackOrder/trackOrderMain.jsx";
import { PendingViewOrderDetails } from "./View/MyAccount/PendingOrderList/pendingViewOrderDetails.jsx";
import { ResetChangePassword } from "./View/ResetChangePassword/ResetChangePassword.jsx";
import { PageNotFound } from "./View/StaticPage/PageNotFound.jsx";
import { ChatBotApiTest } from "./View/ChatBotApiTest/chatBotApiTest.jsx";
import { CHAT_API_TEST_ENABLED } from "./constants";
const PAGES = {
  HOME: "/Home",
  CATEGORY: "/Category",
  CATEGORY_EAPATH: "/Category/:cid/:pcid/:eapath",
  CATEGORY_EAPATH_FILTER: "/Category/:cid/:pcid/:eapath/:filter",
  BRAND: "/brand",
  POWERSEARCH: "/PowerSearch",
  POWERSEARCHNEW: "/PowerSearchNew",
  POWERSEARCH_SEARCH: "/PowerSearch/:srctxt",
  ORDER_DETAIL: "/OrderDetails",
  CHECKOUT: "/Checkout",
  BILLINFO_ORDERTRACKING: "/OrderTracking/:trackOrderNumber",
  BILLINFO: "/BillInfo/:orderId",
  VIEWORDERSTATUS: "/ViewOrder/:orderId",
  HYDPAGE: "/product/:fid",
  MYACCOUNT: "/myaccount",
  ORDERHISTORY: "/myaccount/order-history",
  PENDINGORDERS: "/myaccount/pending-orders",
  PENDINGORDERS_VIEW: "/myaccount/pending-orders/:orderId",
  VIEWORDER: "/myaccount/order-history/:page/:orderId",
  ORDERHISTROY_TRACK_ORDER: "/myaccount/order-history/:page/:trackOrderNumber",
  FAVORITEPRODUCT_LIST: "/myaccount/favorite-products",
  FAVORITEPRODUCT_EDIT: "/myaccount/favorite-products/:listId",
  MYWALLET: "/myaccount/mywallet",
  MYWALLETTILL: "/myaccount/mywallet/:status/:transId",
  MYWALLETADD: "/myaccount/mywallet/add-new",
  MYWALLETADDTILL: "/myaccount/mywallet/add-new/:transId",
  MYADDRESSBOOK: "/myaccount/myaddressbook",
  MYACCOUNTDETAIL: "/myaccount/myaccountdetails",
  MYADDRESSBOOKADD: "/myaccount/myaddressbook/:type",
  MYADDRESSBOOKEDIT: "/myaccount/myaddressbook/:type/:editId",
  WEBSITESETTING: "/myaccount/website-settings",
  AIACCESS: "/myaccount/ai-access",
  OAUTHAUTHORIZE: "/oauth/authorize",
  CHATBOTAPITEST: "/chatbot-api-test",
  CHANGEPASSWORD: "/myaccount/change-password",
  CHANGEUSERNAME: "/myaccount/change-username",
  FORGOTPASSWORD: "/forgotpassword",
  FORGOTUSERNAME: "/forgotusername",
  LOGIN: "/login",
  SIGNUP: "/signup",
  RESETPASSWORD: "/resetPassword",
  RESETPASSWORD_LOAD: "/resetPassword/:loginname/:newpassword/:userid",
  ALGOLIASEARCH: "/algoliapowerSearch",
  SEARCH: "/search",
  SEARCHCLASSIC: "/searchclassic",
  AVTVSATINSRALLATION_CT: "/av-tv-sat-installation/",
  CABLESCONNECTORS_CT: "/cables-connectors/",
  AUDIOSPEAKERSPA_CT: "/audio-speakers-pa/",
  DATACOMPUTER_CT: "/data-computer/",
  SECURITY_CT: "/security/",
  CELLULARACCESSORIES_CT: "/cellular-accessories/",
  COMMUNICATIONACCESSORIES_CT: "/communication-accessories/",
  TOOLSandTEST_CT: "/tools-test/",
  POWERLIGHTING_CT: "/power-lighting/",
  AUTOMOTIVE_CT: "/automotive/",
  ELECTRONICCOMPONENTS_CT: "/electronic-components/",
  SERVICEREPAIR_CT: "/service-repair-parts/",
  NEWPRODUCTS_CT: "/new-products/",
  CLEARANCE_CT: "/clearance-products/",
  BRANDMODEL: "/brandmodel/",
  BRANDS_CT: "/brands/",
  ALGOLIA_CATEGORY: "/algoliacategory/*",
  COMPANYUSER: "/myaccount/company-users",
  COMPANYUSEREDIT: "/myaccount/company-users-editusers/:userid",
  COMPANYUSERADD: "/myaccount/company-users-addusers",
  ONLINE_CATALOGUE: "/online-catalogue",
  ONLINE_CATALOGUES: "/wesnews",
  SPECIALPRODUCT: "/special-products",
  VIEWEBOOK: "/ViewEbook/:ebookpath",
  FEATUREDPRODUCTS: "/featured-products",
  MANUFACTURER: "/manufacturer",
  ABOUTUS: "/aboutus",
  CONTACTUS: "/contactus",
  TERMSANDCONDITIONS: "/termsandconditions",
  PRIVACYPOLICY: "/privacypolicy",
  JOBENQUIRIES: "/jobenquiries",
  PAYMENTPOLICY: "/paymentpolicy",
  USERGUIDE: "/userguide",
  FAQ: "/faq",
  PAYONLINE: "/Payonline/:urlref",
  MAKEPAYMENT: "/MakePayment/:type",
  PAYACCOUNT: "/payaccount",
  PAYACCOUNT_LEGACY: "/pay-account",
  PAYACCOUNT_SUCCESS: "/payaccount/success",
  PAYINVOICE: "/payinvoice",
  PAYONLINEAFTERLOGIN: "/myaccount/order-history/:page/:urlref",
  PENDING_ORDER_DETAIL: "/OrderDetails/:orderId",
  PENDING_CHECKOUT: "/Checkout/:orderId",
  RESETCHANGEPASSWORD: "/resetchangepassword",
  RESETCHANGEPASSWORD_LOAD: "/resetchangepassword/:userid",
  PRODUCT_NEW_LAYOUT: "/product-new-layout",
  NOTFOUND: "*",
};

const routesConfigBase = [
  { path: "/", Component: HomePageMainContainer, allowGuest: true, title: "" },
  { path: PAGES.HOME, Component: HomePageMainContainer, allowGuest: true, title: "" },
  { path: `${PAGES?.BRAND}/:brandName?`, Component: ManufacturerPage, title: "Brands" },
  {
    path: PAGES.POWERSEARCH_SEARCH,
    Component: PowerSearchMainLite,
    title: "Search Results",
  },
  { path: PAGES.ORDER_DETAIL, Component: OrderDetails, restrictBrowseOnly: true, title: "My Cart" },
  { path: PAGES.CHECKOUT, Component: CheckoutMain, restrictBrowseOnly: true, title: "Checkout" },

  { path: PAGES.HYDPAGE, Component: ProductHybridMain, title: "Product Details" },

  { path: PAGES.MYACCOUNT, Component: MyAccount, title: "My Account" },
  { path: PAGES.ORDERHISTORY, Component: MyOrderHistoryMain, title: "My Order History" },
  { path: PAGES.PENDINGORDERS, Component: MyPendingOrderMain, title: "Pending Orders" },
  {
    path: PAGES.PENDINGORDERS_VIEW,
    Component: MyPendingOrderMain,
    // title: ({ orderId }) => (orderId ? `Pending Order #${orderId}` : "Pending Orders"),
    title: "View Pending Order",
  },
  {
    path: PAGES.VIEWORDER,
    Component: MyOrderHistoryMain,
    //title: ({ orderId }) => (orderId ? `Order #${orderId}` : "Order History"),
    title: "View Order History",
  },
  { path: PAGES.ORDERHISTROY_TRACK_ORDER, Component: MyOrderHistoryMain, title: "My Order History" },
  { path: PAGES.MYWALLET, Component: MyWalletMain, title: "My Wallet" },
  { path: PAGES.MYWALLETTILL, Component: MyWalletMain, title: "My Wallet" },
  { path: PAGES.MYWALLETADD, Component: MyWalletNewCard, title: "Add New Card" },
  { path: PAGES.MYWALLETADDTILL, Component: MyWalletNewCard, title: "Add New Card" },
  { path: PAGES.FAVORITEPRODUCT_LIST, Component: MyFavouriteProductMain, title: "My Favourite Products" },
  { path: PAGES.FAVORITEPRODUCT_EDIT, Component: MyFavouriteProductMain, title: "Edit Favourite List" },
  { path: PAGES.MYADDRESSBOOK, Component: MyAddressBookMain, title: "Shipping Address Book" },
  {
    path: PAGES.MYADDRESSBOOKADD,
    Component: MyAddressBookMain,
    title: ({ type }) => (type === "new" || type === "add" ? "Add Shipping Address" : "Shipping Address Book"),
  },
  { path: PAGES.MYADDRESSBOOKEDIT, Component: MyAddressBookMain, title: "Edit Address" },
  { path: PAGES.MYACCOUNTDETAIL, Component: MyAccountProfile, title: "My Account Details" },
  { path: PAGES.CHANGEPASSWORD, Component: ChangePassword, title: "Change Password" },
  { path: PAGES.CHANGEUSERNAME, Component: ChangeUsername, title: "Change Username" },
  { path: PAGES.WEBSITESETTING, Component: WebsiteSettings, title: "Website Settings" },
  { path: PAGES.AIACCESS, Component: AiAccessTokens, title: "AI Access" },
  { path: PAGES.SEARCH, Component: PowerSearchMainLite, title: "Search Results" },
  { path: PAGES.AVTVSATINSRALLATION_CT + "*", Component: AlgoliaCategoryMain, title: "AV, TV & Sat Installation" },
  { path: PAGES.CABLESCONNECTORS_CT + "*", Component: AlgoliaCategoryMain, title: "Cables & Connectors" },
  { path: PAGES.AUDIOSPEAKERSPA_CT + "*", Component: AlgoliaCategoryMain, title: "Audio, Speakers & PA" },
  { path: PAGES.DATACOMPUTER_CT + "*", Component: AlgoliaCategoryMain, title: "Data & Computer" },
  { path: PAGES.SECURITY_CT + "*", Component: AlgoliaCategoryMain, title: "Security" },
  { path: PAGES.CELLULARACCESSORIES_CT + "*", Component: AlgoliaCategoryMain, title: "Cellular Accessories" },
  { path: PAGES.BRANDS_CT + "*", Component: AlgoliaCategoryMain, title: "Brands" },
  { path: PAGES.BRANDMODEL + "*", Component: CompatibleBrandMain, title: "Compatible Products" },
  {
    path: PAGES.COMMUNICATIONACCESSORIES_CT + "*",
    Component: AlgoliaCategoryMain,
    title: "Communication Accessories",
  },
  { path: PAGES.TOOLSandTEST_CT + "*", Component: AlgoliaCategoryMain, title: "Tools & Test" },
  { path: PAGES.POWERLIGHTING_CT + "*", Component: AlgoliaCategoryMain, title: "Power & Lighting" },
  { path: PAGES.AUTOMOTIVE_CT + "*", Component: AlgoliaCategoryMain, title: "Automotive" },
  { path: PAGES.ELECTRONICCOMPONENTS_CT + "*", Component: AlgoliaCategoryMain, title: "Electronic Components" },
  { path: PAGES.SERVICEREPAIR_CT + "*", Component: AlgoliaCategoryMain, title: "Service & Repair Parts" },
  { path: PAGES.NEWPRODUCTS_CT + "*", Component: AlgoliaCategoryMain, title: "New Products" },
  { path: PAGES.CLEARANCE_CT + "*", Component: AlgoliaCategoryMain, title: "Clearance Products" },
  { path: PAGES.VIEWEBOOK, Component: EbookMain, title: "Online Catalogue" },
  { path: PAGES.SPECIALPRODUCT, Component: ProductPageAlgolia, title: "Special Products" },
  { path: PAGES.FEATUREDPRODUCTS, Component: ProductPageAlgolia, title: "Featured Products" },
  { path: PAGES.PAYONLINEAFTERLOGIN, Component: PayOnlineMain, title: "Pay Online" },
  {
    path: PAGES.PENDING_ORDER_DETAIL,
    Component: PendingViewOrderDetails,
    restrictBrowseOnly: true,
    //title: ({ orderId }) => (orderId ? `Order #${orderId}` : "Order Details"),
    title: "View Order Details",
  },
  { path: PAGES.PENDING_CHECKOUT, Component: CheckoutMain, restrictBrowseOnly: true, title: "Checkout" },
];

// The only My Account pages a browse-only user may open. Everything else under
// /myaccount (plus the checkout/order-details pages tagged above) is blocked.
const BROWSE_ONLY_ALLOWED_PATHS = [PAGES.MYACCOUNT, PAGES.MYACCOUNTDETAIL, PAGES.CHANGEPASSWORD, PAGES.CHANGEUSERNAME];

// Browse-only users (userRole === "4") may not reach checkout/order-details pages
// (tagged explicitly above) nor any My Account page other than the allowlist.
const routesConfig = routesConfigBase.map((route) => {
  const isMyAccountPage = String(route.path).toLowerCase().startsWith("/myaccount");
  const isBrowseOnlyAllowed = BROWSE_ONLY_ALLOWED_PATHS.includes(route.path);
  return {
    ...route,
    restrictBrowseOnly: route.restrictBrowseOnly === true || (isMyAccountPage && !isBrowseOnlyAllowed),
  };
});

const routesWithoutMasterConfig = ["tillpayment", "till-mywallet"];

const mcpRoutes = [
  { path: PAGES.OAUTHAUTHORIZE, Component: OAuthConsent, title: "Connect an Application" },
  ...(CHAT_API_TEST_ENABLED
    ? [{ path: PAGES.CHATBOTAPITEST, Component: ChatBotApiTest, title: "ChatBot API Test" }]
    : []),
];
const routesWithoutLogin = [
  {
    path: PAGES.FORGOTPASSWORD,
    Component: ForgotPasswordMain,
    redirectIfAuthenticated: true,
    title: "Forgot Password",
  },
  {
    path: PAGES.FORGOTUSERNAME,
    Component: ForgotUsernameMain,
    redirectIfAuthenticated: true,
    title: "Forgot Username",
  },
  { path: PAGES.LOGIN, Component: LoginFormContainer, redirectIfAuthenticated: true, title: "" },
  { path: PAGES.RESETPASSWORD, Component: ResetPasswordComp, redirectIfAuthenticated: true, title: "Reset Password" },
  {
    path: PAGES.RESETPASSWORD_LOAD,
    Component: ResetPasswordComp,
    redirectIfAuthenticated: true,
    title: "Reset Password",
  },
  { path: PAGES.SIGNUP, Component: SignupMain, redirectIfAuthenticated: true, title: "Sign Up" },
  { path: PAGES.ABOUTUS, Component: AboutUs, title: "About Us" },
  { path: PAGES.CONTACTUS, Component: ContactUs, title: "Contact Us" },
  { path: PAGES.TERMSANDCONDITIONS, Component: Termsandconditions, title: "Terms & Conditions" },
  { path: PAGES.PRIVACYPOLICY, Component: PrivacyPolicy, title: "Privacy Policy" },
  { path: PAGES.JOBENQUIRIES, Component: JobEnquiries, title: "Job Enquiries" },
  { path: PAGES.PAYMENTPOLICY, Component: PaymentPolicy, title: "Payment Policy" },
  { path: PAGES.USERGUIDE, Component: UserGuide, title: "User Guide" },
  { path: PAGES.FAQ, Component: FAQ, title: "Help" },
  { path: PAGES.ONLINE_CATALOGUE, Component: Online_catalogue_Main, title: "Online Catalogue" },
  { path: PAGES.ONLINE_CATALOGUES, Component: Online_catalogue_Main, title: "WES News" },
  { path: PAGES.VIEWEBOOK, Component: EbookMain, title: "Online Catalogue" },
  { path: PAGES.PAYONLINE, Component: PayOnlineMain, title: "Pay Online" },
  { path: PAGES.MAKEPAYMENT, Component: MakePaymentMail, title: "Make Payment" },
  {
    path: PAGES.BILLINFO,
    Component: BillInfoMain,
    //title: ({ orderId }) => (orderId ? `Order #${orderId}` : "Order Confirmation"),
    titlt: "Bill Info",
  },
  {
    path: PAGES.VIEWORDERSTATUS,
    Component: OrderStatusMain,
    //    title: ({ orderId }) => (orderId ? `Order #${orderId}` : "Order Status"),
    title: "View Order Status",
  },
  {
    path: `${PAGES.PAYACCOUNT_SUCCESS}/:transactionId/:ref?`,
    Component: PaymentSuccess,
    title: "Payment Successful",
  },
  {
    path: `${PAGES.PAYACCOUNT}/:urlref?`,
    Component: PayAccountMain,
    sessionGuardWhenAuthenticated: true,
    title: "Pay Account",
  },
  {
    path: `${PAGES.PAYINVOICE}/:urlref?`,
    Component: PayInvoiceMain,
    title: "Proforma Invoice Payment",
  },
  {
    path: `${PAGES.PAYACCOUNT_LEGACY}/:urlref?`,
    Component: PayAccountLegacyRedirect,
    title: "Pay Account",
  },
  {
    path: PAGES.BILLINFO_ORDERTRACKING,
    Component: TrackOrderMain,
    //title: ({ trackOrderNumber }) => (trackOrderNumber ? `Track Order #${trackOrderNumber}` : "Track Order"),
    title: "Bill Info Order Tracking",
  },
  {
    path: PAGES.RESETCHANGEPASSWORD,
    Component: ResetChangePassword,
    redirectIfAuthenticated: true,
    title: "Reset Password",
  },
  {
    path: PAGES.RESETCHANGEPASSWORD_LOAD,
    Component: ResetChangePassword,
    redirectIfAuthenticated: true,
    title: "Reset Password",
  },
];

const adminUserPages = [
  { path: PAGES.COMPANYUSER, Component: CompanyUsers, title: "Company Users" },
  { path: PAGES.COMPANYUSEREDIT, Component: CompanyUsersEditusers, title: "Edit User" },
  { path: PAGES.COMPANYUSERADD, Component: CompanyUsersEditusers, title: "Add New User" },
  { path: PAGES.COMPANYUSEREDIT, Component: CompanyUsersEditusers, title: "Edit User" },
];

const PAGES_WITHOUT_FOOTER = [PAGES.ORDER_DETAIL, PAGES.CHECKOUT];

// Catch-all: any URL that matches none of the routes above renders the 404 page.
// Must always be registered last inside <Routes>.
const notFoundRoute = { path: PAGES.NOTFOUND, Component: PageNotFound, title: "Page Not Found" };

// Every route, stripped down to what the browser-tab title needs. Fed to
// matchRoutes() in App.js, which ranks paths exactly the way <Routes> does, so
// the title always belongs to the page actually on screen. `title` is either a
// plain string or (params) => string for pages named after a URL parameter.
// Pages whose name only exists after a fetch (product, category, brand, search)
// keep a static label here and override it with usePageTitle once data lands.
const routeTitles = [
  ...routesWithoutLogin,
  ...routesConfig,
  ...mcpRoutes,
  ...adminUserPages,
  notFoundRoute,
].map(({ path, title }) => ({ path, title }));

export {
  routesConfig,
  PAGES_WITHOUT_FOOTER,
  PAGES,
  routesWithoutMasterConfig,
  routesWithoutLogin,
  mcpRoutes,
  adminUserPages,
  notFoundRoute,
  routeTitles,
};
